import {
  BinaryOperator,
  ExpressionEvaluator,
  ExpressionEvaluatorSanitiseKeyFn,
  ExpressionEvaluatorType
} from './interfaces/expression-evaluator';
import { UnaryExpression } from './unary-expression';
import { IdentifierExpression } from './identifier-expression';
import { LiteralExpression } from './literal-expression';
import { PrimitiveTypes } from '../shared/interfaces/generics';

export class BinaryExpression
  implements ExpressionEvaluator<Record<string, PrimitiveTypes>, boolean>
{
  operator: BinaryOperator | undefined;

  left: BinaryExpression | UnaryExpression | IdentifierExpression | LiteralExpression | undefined;

  right: BinaryExpression | UnaryExpression | IdentifierExpression | LiteralExpression | undefined;

  getType() {
    return ExpressionEvaluatorType.BINARY_EXPRESSION;
  }

  evaluate(
    model: Record<string, PrimitiveTypes>,
    getSanitiseKey: ExpressionEvaluatorSanitiseKeyFn
  ): boolean {
    /**
     * At the leaf level of recursion tree,
     * resolved values will always be primitives
     */
    const left: PrimitiveTypes = this.left ? this.left.evaluate(model, getSanitiseKey) : false;
    const right: PrimitiveTypes = this.right ? this.right.evaluate(model, getSanitiseKey) : false;

    switch (this.operator) {
      case BinaryOperator.AND:
        return !!(left && right);

      case BinaryOperator.OR:
        return !!(left || right);

      case BinaryOperator.EQUALS:
        return left === right;

      case BinaryOperator.GREATER_THAN:
        return left > right;

      case BinaryOperator.GREATER_THAN_EQUAL_TO:
        return left >= right;

      case BinaryOperator.LESSER_THAN:
        return left < right;

      case BinaryOperator.LESSER_THAN_EQUAL_TO:
        return left <= right;

      default:
        return false;
    }
  }
}
